import React, { useMemo } from 'react'
import LineTagAltIcon from 'LuxKit/Icons/line/LineTagAltIcon'
import PromotionLabel from 'LuxKit/Label/PromotionLabel'

interface Props {
  offer: App.CarHireOffer
}
function CarHireDiscountTag(props: Props) {
  const { offer } = props

  const discountPercentage = useMemo(() => offer.rateOptions[0]?.payNowDiscountPercentage ?? 0, [offer.rateOptions])

  if (discountPercentage === 0) {
    return null
  }

  return <PromotionLabel icon={<LineTagAltIcon />} variant="default">{discountPercentage}% off applied</PromotionLabel>
}

export default CarHireDiscountTag
